import { TestTube, Settings2, RefreshCw } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const protocolSteps = [{
  title: "Measure",
  description: "We Measure key hormone levels and imbalances,",
  icon: TestTube
}, {
  title: "Optimize",
  description: "then Optimize with precision-based therapies designed to restore energy, mood, metabolism, and vitality.",
  icon: Settings2
}, {
  title: "Maintain",
  description: "Maintained through routine monitoring and personalized adjustments.",
  icon: RefreshCw
}];
export default function OHormoneOptimization() {
  return <section id="o-hormone-optimization" className="bg-[hsl(210,10%,15%)] text-white py-[128px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="font-default text-4xl md:text-5xl font-light tracking-wide text-white">
            Balance what drives everything.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
          {protocolSteps.map((step, i) => {
          const Icon = step.icon;
          return <Card key={i} data-index={i} className="bg-transparent border-none shadow-none text-center flex flex-col items-center">
                <CardHeader className="pb-4 flex flex-col items-center">
                  <div className="mb-6 p-4 rounded-full bg-white/5 border border-white/10">
                    <Icon strokeWidth={1} className="w-10 h-10 text-white" aria-hidden="true" />
                  </div>
                  <CardTitle className="font-default text-xl font-medium tracking-[0.3em] uppercase text-white">
                    {step.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-white/70 font-sans leading-relaxed text-base md:text-lg font-light">
                    {step.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}